const preliminaryDomesticSales = {
  "blocks": [
    {
      "key": "eg0sf",
      "text": "Hi {{firstName}},",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "e9has",
      "text": "Thank you for booking with evoJets. Attached is your preliminary itinerary, up-to-date invoice and catering menu.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "ea533",
      "text": "FBO details will be provided once finalized, likely within 12-48hrs of departure.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "c5jj1",
      "text": "Please provide the following when you have a moment:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 52, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "a9j4n",
      "text": "Credit card on file for incidental charges",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "4ress",
      "text": "**Please upload your credit card details to our secure portal linked here. The password to log onto the portal is fly-private",
      "type": "ordered-list-item",
      "depth": 1,
      "inlineStyleRanges": [{ "offset": 114, "length": 11, "style": "BOLD" }],
      "entityRanges": [{ "offset": 69, "length": 4, "key": 0 }],
      "data": {},
    }, {
      "key": "4ltdn",
      "text": "Full names of all passengers (FIRST/MIDDLE/LAST) & DOB as they appear on ID",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "93f3m",
      "text": "All passengers age 18 and older will be required to present a TSA compliant form of ID  **",
      "type": "ordered-list-item",
      "depth": 1,
      "inlineStyleRanges": [],
      "entityRanges": [{ "offset": 62, "length": 24, "key": 1 }],
      "data": {},
    }, {
      "key": "fill9",
      "text": "Estimated Weight of Each Passenger and Piece of Luggage",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "am25o",
      "text": "Catering Requests",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "73ee2",
      "text": "Ground Transportation Requests",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "7p18h",
      "text": "** Catering and ground transportation will be charged to you separately **",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn1",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn9",
      "text": "Payment Information:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 20, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "57k9t",
      "text": "To finalize this booking, payment will be required for the owner to continue the hold on the aircraft. Please note the wire instructions are included in your electronic contract that was sent to your email.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn3",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "dk3h6",
      "text": "Payment Method Required: [TBD]",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 30, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "8r24u",
      "text": "Payment Due By: [TBD]",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 21, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "3c7d4",
      "text": "Payment Amount Due: $XX,XXX",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 27, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn2",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "ftcl6",
      "text": "Kindly contact me should you have any additional questions or concerns.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
  ],
  "entityMap": {
    "0": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "href": "https://secure.evojets.com/?password-protected=login&redirect_to=https%3A%2F%2Fsecure.evojets.com%2Fcards%2F",
        "url": "https://secure.evojets.com/?password-protected=login&redirect_to=https%3A%2F%2Fsecure.evojets.com%2Fcards%2F",
      },
    },
    "1": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "href": "https://www.tsa.gov/travel/security-screening/identification",
        "url": "https://www.tsa.gov/travel/security-screening/identification",
      },
    },
  },
};

const preliminaryDomesticOps = {
  "blocks": [
    {
      "key": "8phit",
      "text": "Hi {{firstName}},",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "fglg7",
      "text": "Thank you for booking with evoJets! Attached is your preliminary itinerary and invoice.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "a5id3",
      "text": "We as the Operations Team will be your main point of contact for all logistics with the trip moving forward. **Be sure to include both ops@evojets.com  as well as your sales rep ({{ownerEmail}}) on all communications**",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 109, "length": 200, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "bqphv",
      "text": "Crew names, Tail Number, and FBO details will be provided once finalized, likely within 12-48hrs of departure.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "b0ok7",
      "text": "Please provide the following when you have a moment:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "d2hm3",
      "text": "Credit card on file for incidental charges",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "7a39g",
      "text": "**Please upload your credit card details to our secure portal linked here. The password to log onto the portal is fly-private",
      "type": "ordered-list-item",
      "depth": 1,
      "inlineStyleRanges": [{ "offset": 114, "length": 11, "style": "BOLD" }],
      "entityRanges": [{ "offset": 69, "length": 4, "key": 0 }],
      "data": {},
    }, {
      "key": "d8mv1",
      "text": "Full names of all passengers (FIRST/MIDDLE/LAST) & DOB as they appear on ID",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "4kksi",
      "text": "All passengers age 18 and older will be required to present a TSA compliant form of ID",
      "type": "ordered-list-item",
      "depth": 1,
      "inlineStyleRanges": [],
      "entityRanges": [{ "offset": 62, "length": 24, "key": 1 }],
      "data": {},
    }, {
      "key": "8ig0n",
      "text": "Estimated Weights of Passengers and Luggage",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "2s8t1",
      "text": "Catering Requests (Catering menu attached)",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "4aof0",
      "text": "Ground Transportation Requirements",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "df3hb",
      "text": "** Catering and ground transportation will be charged to you separately **",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn2",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "b9skk",
      "text": "Payment Information:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 20, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "7j1uk",
      "text": "To finalize this booking, payment will be required for the owner to continue the hold on the aircraft. Please note the wire instructions and a credit card authority are included in your contract packet through HelloSign.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn3",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "5uq37",
      "text": "Payment Method Required: [TBD]",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 30, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "ctcpb",
      "text": "Payment Due By: [TBD]",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 21, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "404l1",
      "text": "Payment Amount Due: $XX,XXX",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 27, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn4",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "60kfr",
      "text": "Please contact us should you have any questions.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "hcnb1",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "ojnn",
      "text": " ",
      "type": "atomic",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [
        {
          "offset": 0,
          "length": 1,
          "key": 2,
        },
      ],
      "data": {},
    },
    {
      "key": "u0pu",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "2553k",
      "text": "Daniel A'Hara",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 13,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "aq28f",
      "text": "Ph: (347) 325-2358  ",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 3,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "48kf6",
      "text": "VP, Flight Operations",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "6hapb",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "dh30j",
      "text": "Chase Beitzel",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 13,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "61orf",
      "text": "Ph: (347) 952-0214",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 3,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "3m8aj",
      "text": "Associate, Flight Operations",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "7hapb",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "4hgea",
      "text": "Mollie Gallagher",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 16,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "d4blh",
      "text": "Ph: (917) 772-9986",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 3,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "2altv",
      "text": "Associate, Flight Operations",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "9hapb",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "fvgk4",
      "text": "ops@evojets.com | www.evojets.com ",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "fh8ob",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "ngmh",
      "text": "evoJets is an air charter broker - we do not own or operate aircraft.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "4jq9f",
      "text": "Read our full disclaimer. ",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [
        {
          "offset": 9,
          "length": 15,
          "key": 3,
        },
      ],
      "data": {},
    },
  ],
  "entityMap": {
    "0": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "href": "https://secure.evojets.com/?password-protected=login&redirect_to=https%3A%2F%2Fsecure.evojets.com%2Fcards%2F",
        "url": "https://secure.evojets.com/?password-protected=login&redirect_to=https%3A%2F%2Fsecure.evojets.com%2Fcards%2F",
      },
    },
    "1": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "href": "https://www.tsa.gov/travel/security-screening/identification",
        "url": "https://www.tsa.gov/travel/security-screening/identification",
      },
    },
    "2": {
      "type": "IMAGE",
      "mutability": "MUTABLE",
      "data": {
        "src": "https://hq.evojets.com/ops-email-template-logo.png",
        "height": "auto",
        "width": "auto",
        "alignment": "left",
      },
    },
    "3": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "url": "https://www.evojets.com/disclaimer/",
        "title": "<span class=\"s2\">full disclaimer</span>",
        "targetOption": "",
        "_map": {
          "type": "LINK",
          "mutability": "MUTABLE",
          "data": {
            "url": "https://www.evojets.com/disclaimer/",
            "title": "<span class=\"s2\">full disclaimer</span>",
            "targetOption": "",
          },
        },
      },
    },
  },
};

const preliminaryInternationalSales = {
  "blocks": [
    {
      "key": "1c5t0",
      "text": "Hi {{firstName}},",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "5jvnu",
      "text": "Thank you for booking with evoJets. Attached is your preliminary itinerary, up-to-date invoice and catering menu.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "f34cr",
      "text": "FBO details will be provided once finalized, likely within 12-48hrs of departure.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "47e8n",
      "text": "Please provide the following when you have a moment:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 52, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "flmuo",
      "text": "Credit card on file for incidental charges",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "892d4",
      "text": "**Please upload your credit card details to our secure portal linked here. The password to log onto the portal is fly-private.",
      "type": "ordered-list-item",
      "depth": 1,
      "inlineStyleRanges": [{ "offset": 114, "length": 11, "style": "BOLD" }],
      "entityRanges": [{ "offset": 69, "length": 4, "key": 0 }],
      "data": {},
    }, {
      "key": "4e1bo",
      "text": "Full names of all passengers (FIRST/MIDDLE/LAST) & DOB as they appear on ID",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "6urk5",
      "text": "Please notify us of any minors onboard without both parents present - a notarized Letter of Consent may be required.",
      "type": "ordered-list-item",
      "depth": 1,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "3tf0s",
      "text": "Copies of Passports and relevant VISAs (if applicable) *",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 55, "length": 1, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "rvqk",
      "text": "Please ensure these are sent 48 to 72 hours prior to departure to ensure the proper clearance is approved from customs*",
      "type": "ordered-list-item",
      "depth": 1,
      "inlineStyleRanges": [{ "offset": 0, "length": 119, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "5cdn6",
      "text": "Estimated Weights of Passengers and Luggage",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "c42dh",
      "text": "Catering Requests",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "c7o7",
      "text": "Ground Transportation Requirements",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "3omi7",
      "text": "*Please note ground transportation and catering will be charged separately*",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "1k6h2",
      "text": "**Airports require landing/departing slot approval upon booking. Departure times are also subject to weather and airport flow programs - Europe/Asia",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn2",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "b0s3r",
      "text": "Payment Information:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 20, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "9mh5c",
      "text": "To finalize this booking, payment will be required for the owner to continue the hold on the aircraft. Please note the wire instructions are included in your electronic contract that was sent to your email.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn3",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "16hq6",
      "text": "Payment Method Required: [TBD]",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 30, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "5je17",
      "text": "Payment Due By: [TBD]",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 21, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "bqfp3",
      "text": "Payment Amount Due: $XX,XXX",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 27, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn4",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "bl5fk",
      "text": "Kindly contact me should you have any additional questions or concerns.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
  ],
  "entityMap": {
    "0": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "href": "https://secure.evojets.com/?password-protected=login&redirect_to=https%3A%2F%2Fsecure.evojets.com%2Fcards%2F",
        "url": "https://secure.evojets.com/?password-protected=login&redirect_to=https%3A%2F%2Fsecure.evojets.com%2Fcards%2F",
      },
    },
  },
};

const preliminaryInternationalOps = {
  "blocks": [
    {
      "key": "a6tal",
      "text": "Hi {{firstName}},",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "7gnpu",
      "text": "Thank you again for booking with evoJets! Attached is your preliminary itinerary and invoice for this trip.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "cdpna",
      "text": "We as the Operations Team will be your main point of contact for all logistics with the trip moving forward. **Be sure to include both ops@evojets.com  as well as your sales rep ({{ownerEmail}}) on all communications**",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 109, "length": 200, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "fkl2s",
      "text": "Crew names, Tail Number, and FBO details will be provided once finalized, likely within 12-48hrs of departure.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "bh2dd",
      "text": "Please provide the following when you have a moment:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "a2io7",
      "text": "Credit card on file for incidental charges",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "d8r7t",
      "text": "**Please upload your credit card details to our secure portal linked here. The password to log onto the portal is fly-private.",
      "type": "ordered-list-item",
      "depth": 1,
      "inlineStyleRanges": [{ "offset": 114, "length": 11, "style": "BOLD" }],
      "entityRanges": [{ "offset": 69, "length": 4, "key": 0 }],
      "data": {},
    }, {
      "key": "9qn9i",
      "text": "Full names of all passengers (FIRST/MIDDLE/LAST) & DOB as they appear on ID",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "7qr7n",
      "text": "Please notify us of any minors onboard without both parents present - a notarized Letter of Consent may be required.",
      "type": "ordered-list-item",
      "depth": 1,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "9lm5i",
      "text": "Estimated Weights of Passengers and Luggage",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "bfpi0",
      "text": "Copies of Passports and relevant VISAs (if applicable) *",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 55, "length": 1, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "44pf4",
      "text": "Please ensure these are sent 48 to 72 hours prior to departure to ensure the proper clearance is approved from customs*",
      "type": "ordered-list-item",
      "depth": 1,
      "inlineStyleRanges": [{ "offset": 0, "length": 119, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "7e5lv",
      "text": "Catering Requests",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "4opf8",
      "text": "Ground Transportation Requirements",
      "type": "ordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "3sed8",
      "text": "*Please note ground transportation and catering will be charged separately*",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "d4jrh",
      "text": "**Airports require landing/departing slot approval upon booking. Departure times are also subject to weather and airport flow programs - Europe/Asia",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn2",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "96erq",
      "text": "Payment Information:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 20, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "e642h",
      "text": "To finalize this booking, payment will be required for the owner to continue the hold on the aircraft. Please note the wire instructions are included in your electronic contract that was sent to your email.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn3",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "a76ej",
      "text": "Payment Method Required: [TBD]",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 30, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "e8441",
      "text": "Payment Due By: [TBD]",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 21, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "5pqs6",
      "text": "Payment Amount Due: $XX,XXX",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 27, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn4",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "8pv3q",
      "text": "Please contact us should you have any additional questions or concerns.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "hcnb1",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "ojnn",
      "text": " ",
      "type": "atomic",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [
        {
          "offset": 0,
          "length": 1,
          "key": 1,
        },
      ],
      "data": {},
    },
    {
      "key": "u0pu",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "2553k",
      "text": "Daniel A'Hara",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 13,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "aq28f",
      "text": "Ph: (347) 325-2358  ",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 3,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "48kf6",
      "text": "VP, Flight Operations",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "6hapb",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "dh30j",
      "text": "Chase Beitzel",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 13,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "61orf",
      "text": "Ph: (347) 952-0214",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 3,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "3m8aj",
      "text": "Associate, Flight Operations",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "7hapb",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "4hgea",
      "text": "Mollie Gallagher",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 16,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "d4blh",
      "text": "Ph: (917) 772-9986",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 3,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "2altv",
      "text": "Associate, Flight Operations",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "9hapb",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "fvgk4",
      "text": "ops@evojets.com | www.evojets.com ",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "fh8ob",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "ngmh",
      "text": "evoJets is an air charter broker - we do not own or operate aircraft.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "4jq9f",
      "text": "Read our full disclaimer. ",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [
        {
          "offset": 9,
          "length": 15,
          "key": 2,
        },
      ],
      "data": {},
    },
  ],
  "entityMap": {
    "0": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "href": "https://secure.evojets.com/?password-protected=login&redirect_to=https%3A%2F%2Fsecure.evojets.com%2Fcards%2F",
        "url": "https://secure.evojets.com/?password-protected=login&redirect_to=https%3A%2F%2Fsecure.evojets.com%2Fcards%2F",
      },
    },
    "1": {
      "type": "IMAGE",
      "mutability": "MUTABLE",
      "data": {
        "src": "https://hq.evojets.com/ops-email-template-logo.png",
        "height": "auto",
        "width": "auto",
        "alignment": "left",
      },
    },
    "2": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "url": "https://www.evojets.com/disclaimer/",
        "title": "<span class=\"s2\">full disclaimer</span>",
        "targetOption": "",
        "_map": {
          "type": "LINK",
          "mutability": "MUTABLE",
          "data": {
            "url": "https://www.evojets.com/disclaimer/",
            "title": "<span class=\"s2\">full disclaimer</span>",
            "targetOption": "",
          },
        },
      },
    },
  },
};

const finalSales = {
  "blocks": [
    {
      "key": "dttfb",
      "text": "Hi {{firstName}},",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "58od",
      "text": "Kindly find attached the itinerary for your flight on DATE/TIME. Please confirm everything is accurate.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 54, "length": 9, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "e0hbe",
      "text": "Your aircraft is going to be a TBD",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 31, "length": 3, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "cavjk",
      "text": "Tail number: TBD",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 16, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn5",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "2b4n0",
      "text": "Departure Location:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 19, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "8brjq",
      "text": "TBD",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn6",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "du326",
      "text": "Arrival Location:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 17, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "a21kn",
      "text": "TBD",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn7",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "ce2lv",
      "text": "Please plan to be at the airport at TBD for your TBD scheduled flight with all required documents to ensure an on-time departure. All passengers age 18 and older will be required to present a TSA compliant form of ID",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        { "offset": 36, "length": 16, "style": "BOLD" }, {
          "offset": 130,
          "length": 86,
          "style": "BOLD",
        },
      ],
      "entityRanges": [{ "offset": 192, "length": 24, "key": 0 }],
      "data": {},
    }, {
      "key": "f7jjs",
      "text": "If you have any questions or concerns please let me know.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "h08d",
      "text": "Enjoy your trip!",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
  ],
  "entityMap": {
    "0": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "href": "https://www.tsa.gov/travel/security-screening/identification",
        "target": "_blank",
        "url": "https://www.tsa.gov/travel/security-screening/identification",
      },
    },
  },
};

const finalOps = {
  "blocks": [
    {
      "key": "bodj0",
      "text": "Hi {{firstName}},",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "4n0fh",
      "text": "Attached is the itinerary for the flight tomorrow, DATE/TIME. Please confirm everything is accurate.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 41, "length": 19, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "d9pkc",
      "text": "**Please be sure to email ops@evojets.com as well as your sales rep ({{ownerEmail}}) on all communications**",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 200, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "6uiac",
      "text": "Your aircraft is going to be a TBD",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 31, "length": 3, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "4ceud",
      "text": "Tail number: TBD",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 16, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn5",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "1tsrm",
      "text": "Departure Location:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 19, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "5kjm4",
      "text": "TBD",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn6",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "4qrlg",
      "text": "Arrival Location:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 17, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "eoebv",
      "text": "TBD",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "chbn7",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "6ebed",
      "text": "Please plan to be at the airport at TBD for your TBD scheduled flight with all required documents to ensure an on-time departure. All passengers age 18 and older will be required to present a TSA compliant form of ID",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        { "offset": 36, "length": 16, "style": "BOLD" }, {
          "offset": 130,
          "length": 86,
          "style": "BOLD",
        },
      ],
      "entityRanges": [{ "offset": 192, "length": 24, "key": 0 }],
      "data": {},
    }, {
      "key": "3r3b9",
      "text": "If you have any questions or concerns please let me know.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "88ctn",
      "text": "Enjoy your trip!",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "hcnb1",
      "text": "",
      "type": "paragraph",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "ojnn",
      "text": " ",
      "type": "atomic",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [
        {
          "offset": 0,
          "length": 1,
          "key": 1,
        },
      ],
      "data": {},
    },
    {
      "key": "u0pu",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "2553k",
      "text": "Daniel A'Hara",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 13,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "aq28f",
      "text": "Ph: (347) 325-2358  ",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 3,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "48kf6",
      "text": "VP, Flight Operations",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "6hapb",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "dh30j",
      "text": "Chase Beitzel",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 13,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "61orf",
      "text": "Ph: (347) 952-0214",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 3,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "3m8aj",
      "text": "Associate, Flight Operations",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "7hapb",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "4hgea",
      "text": "Mollie Gallagher",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 16,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "d4blh",
      "text": "Ph: (917) 772-9986",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [
        {
          "offset": 0,
          "length": 3,
          "style": "BOLD",
        },
      ],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "2altv",
      "text": "Associate, Flight Operations",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "9hapb",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "fvgk4",
      "text": "ops@evojets.com | www.evojets.com ",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "fh8ob",
      "text": "",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "ngmh",
      "text": "evoJets is an air charter broker - we do not own or operate aircraft.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
    {
      "key": "4jq9f",
      "text": "Read our full disclaimer. ",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [
        {
          "offset": 9,
          "length": 15,
          "key": 2,
        },
      ],
      "data": {},
    },
  ],
  "entityMap": {
    "0": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "href": "https://www.tsa.gov/travel/security-screening/identification",
        "target": "_blank",
        "url": "https://www.tsa.gov/travel/security-screening/identification",
      },
    },
    "1": {
      "type": "IMAGE",
      "mutability": "MUTABLE",
      "data": {
        "src": "https://hq.evojets.com/ops-email-template-logo.png",
        "height": "auto",
        "width": "auto",
        "alignment": "left",
      },
    },
    "2": {
      "type": "LINK",
      "mutability": "MUTABLE",
      "data": {
        "url": "https://www.evojets.com/disclaimer/",
        "title": "<span class=\"s2\">full disclaimer</span>",
        "targetOption": "",
        "_map": {
          "type": "LINK",
          "mutability": "MUTABLE",
          "data": {
            "url": "https://www.evojets.com/disclaimer/",
            "title": "<span class=\"s2\">full disclaimer</span>",
            "targetOption": "",
          },
        },
      },
    },
  },
};

const updated = {
  "blocks": [
    {
      "key": "1hgc0",
      "text": "Hi {{firstName}},",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "3teqc",
      "text": "Please see the attached itinerary reflecting the changes discussed as highlighted below:",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "fe9u3",
      "text": "** Changes made **",
      "type": "unordered-list-item",
      "depth": 0,
      "inlineStyleRanges": [{ "offset": 0, "length": 18, "style": "BOLD" }],
      "entityRanges": [],
      "data": {},
    }, {
      "key": "70rdv",
      "text": "If you have any questions or other revisions, please advise as soon as possible.",
      "type": "unstyled",
      "depth": 0,
      "inlineStyleRanges": [],
      "entityRanges": [],
      "data": {},
    },
  ],
  "entityMap": {},
};

export {
  preliminaryDomesticSales,
  preliminaryDomesticOps,
  preliminaryInternationalSales,
  preliminaryInternationalOps,
  finalSales,
  finalOps,
  updated,
};
